<template>
  <span class="font-weight-bold text-center">{{ formattedValue || null }}</span>
</template>

<script>
export default {
  props: {
    arredondamento: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 10,
    },
    mediaMinima: {
      type: Number,
      default: 6,
    },
    value: {
      type: [Number, String],
    },
  },

  computed: {
    formattedValue() {
      if (
        this.value === null ||
        this.value === undefined ||
        this.value === "" ||
        isNaN(this.value)
      ) {
        return "- - -";
      }

      let val = parseFloat(this.value);
      if (this.arredondamento) {
        val = this.roundValue(val);
      }
      if (val === null || val === undefined || isNaN(val)) {
        return "- - -";
      }

      val = val <= this.max ? val : this.max;
      return Number(val).toFixed(1).replace(".", ",");
    },
  },

  watch: {
    value(val) {
      if (val > this.max) {
        this.$emit("change", parseFloat(this.max));
      }
    },
  },

  created() {
    if (this.value > this.max) {
      this.$emit("change", parseFloat(this.max));
    }
  },

  methods: {
    roundValue(val) {
      if (this.value == null || isNaN(val)) {
        return null;
      }

      if (!this.arredondamento) {
        return Number(val).toFixed(1);
      }

      const inteiro = Math.floor(val);
      const decimal = Number((val % 1).toFixed(1));
      if (decimal === 0) {
        return inteiro;
      }
      if (decimal <= 0.2) {
        return inteiro;
      }
      if (decimal <= 0.7) {
        return inteiro + 0.5;
      }

      return inteiro + 1;
    },
  },
};
</script>
